export const baseURL = '/api/v1/twitter_manager' as const;

export default {
  twitterAds: baseURL,
  accounts: `${baseURL}/get_ad_accounts/` as const,
  campaigns: `${baseURL}/get_campaigns` as const,
  lineItems: `${baseURL}/get_line_items/` as const,
  adSettings: `${baseURL}/get_ad_settings/` as const,
  createAd: `${baseURL}/create_ad/` as const,
};
